import { render } from "./RetirarFerramentaTempoPermanencia.vue?vue&type=template&id=29d3d6f0&scoped=true"
import script from "./RetirarFerramentaTempoPermanencia.vue?vue&type=script&lang=js"
export * from "./RetirarFerramentaTempoPermanencia.vue?vue&type=script&lang=js"

import "./RetirarFerramentaTempoPermanencia.vue?vue&type=style&index=0&id=29d3d6f0&scoped=true&lang=css"
import "./RetirarFerramentaTempoPermanencia.vue?vue&type=style&index=1&id=29d3d6f0&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d3d6f0"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QLinearProgress,QTable,QImg,QCard,QTooltip,QTr,QTh,QTd,QBtn,QPagination,QField});
